import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LegalHeader from '../components/LegalHeader';

const TermsOfService = () => {
  const { t } = useLanguage();

  const lastUpdatedDate = '2 de junio de 2026';
  const s = t('termsOfService.sections');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation Header */}
      <LegalHeader />

      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
          <div className="flex justify-center items-center space-x-4 mb-4">
            <img
              src="/farm-logo.png"
              alt="FARM Logo"
              className="w-12 h-12 rounded-xl"
            />
            <h1 className="text-3xl font-bold text-gray-900">{t('termsOfService.title')}</h1>
          </div>
          <p className="text-gray-600">{t('termsOfService.subtitle')}</p>
        </div>
      </div>

      {/* Contenido */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">

          {/* Introducción */}
          <section>
            <p className="text-gray-700 leading-relaxed">{t('termsOfService.intro')}</p>
          </section>

          {/* Información del proveedor */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.provider.title}</h2>
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{s.provider.companyName}</h3>
                  <p className="text-gray-700">ADVISER GROUP COMMUNITY SLU</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{s.provider.taxId}</h3>
                  <p className="text-gray-700">B66883687</p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{s.provider.address}</h3>
                  <p className="text-gray-700">
                    Gran Vía Carles III, 98, 10º<br />
                    08028 Barcelona, España
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">{s.provider.contactEmail}</h3>
                  <p className="text-gray-700">
                    <a href="mailto:support@farmway.dev" className="text-blue-600 hover:text-blue-800">
                      support@farmway.dev
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Descripción del servicio */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.description.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>FARM</strong> {s.description.intro}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.description.features.map((f, i) => <li key={i}>{f}</li>)}
              </ul>
              <p className="mt-4"><strong>Importante:</strong> {s.description.disclaimer}</p>
            </div>
          </section>

          {/* Elegibilidad */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.eligibility.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.eligibility.intro}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.eligibility.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </section>

          {/* Disponibilidad geográfica */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.availability.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.availability.intro}</p>
            </div>
          </section>

          {/* Planes y precios */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.plans.title}</h2>
            <div className="space-y-6">
              <div className="border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.plans.free.title}</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {s.plans.free.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>

              <div className="border border-blue-200 rounded-lg p-6 bg-blue-50">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.plans.premium.title}</h3>
                <p className="text-gray-700 mb-4">{s.plans.premium.intro}</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {s.plans.premium.types.map((t, i) => <li key={i}><strong>{t.split(':')[0]}:</strong>{t.split(':')[1]}</li>)}
                </ul>
                <h4 className="font-semibold text-gray-900 mt-4 mb-2">{s.plans.premium.featuresTitle}</h4>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {s.plans.premium.features.map((f, i) => <li key={i}>{f}</li>)}
                </ul>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.plans.integrations.title}</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {s.plans.integrations.items.map((item, i) => <li key={i}><strong>{item.split(':')[0]}:</strong>{item.split(':')[1]}</li>)}
                </ul>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.plans.familySharing.title}</h3>
                <p className="text-gray-700">{s.plans.familySharing.content}</p>
              </div>
            </div>
          </section>

          {/* Pagos y reembolsos */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.payments.title}</h2>
            <div className="space-y-4 text-gray-700">
              <ul className="list-disc pl-6 space-y-2">
                {s.payments.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </section>

          {/* Uso aceptable */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.acceptableUse.title}</h2>
            <div className="space-y-6 text-gray-700">
              <p>{s.acceptableUse.intro}</p>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.acceptableUse.conduct.title}</h3>
                <p className="mb-4">{s.acceptableUse.conduct.intro}</p>
                <ul className="list-disc pl-6 space-y-2">
                  {s.acceptableUse.conduct.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.acceptableUse.content.title}</h3>
                <p className="mb-4">{s.acceptableUse.content.intro}</p>
                <ul className="list-disc pl-6 space-y-2">
                  {s.acceptableUse.content.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.acceptableUse.commercial.title}</h3>
                <ul className="list-disc pl-6 space-y-2">
                  {s.acceptableUse.commercial.items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.acceptableUse.excessive.title}</h3>
                <p>{s.acceptableUse.excessive.content}</p>
              </div>
            </div>
          </section>

          {/* Limitaciones del servicio */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.limitations.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.limitations.intro}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.limitations.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </section>

          {/* Propiedad intelectual */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.intellectualProperty.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.intellectualProperty.p1}</p>
              <p>{s.intellectualProperty.p2}</p>
            </div>
          </section>

          {/* Privacidad */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.privacy.title}</h2>
            <p className="text-gray-700 leading-relaxed">
              {s.privacy.content}
              <a href="/privacy-policy" className="text-blue-600 hover:text-blue-800 ml-1">
                {s.privacy.link}
              </a>
              {s.privacy.suffix}
            </p>
          </section>

          {/* Limitación de responsabilidad */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.liability.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p><strong>IMPORTANTE:</strong> {s.liability.important}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.liability.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </section>

          {/* Terceros */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.thirdParty.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.thirdParty.intro}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.thirdParty.items.map((item, i) => <li key={i}><strong>{item.name}:</strong> {item.desc}</li>)}
              </ul>
              <p>{s.thirdParty.disclaimer}</p>
            </div>
          </section>

          {/* Interrupciones del servicio */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.interruptions.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.interruptions.p1}</p>
              <p>{s.interruptions.p2}</p>
              <p>{s.interruptions.p3}</p>
            </div>
          </section>

          {/* Indemnización */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.indemnification.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.indemnification.intro}</p>
              <ul className="list-disc pl-6 space-y-2">
                {s.indemnification.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          </section>

          {/* Terminación */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.termination.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.termination.p1}</p>
              <p>{s.termination.p2}</p>
              <p>{s.termination.p3}</p>
            </div>
          </section>

          {/* Disposiciones comunes */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.commonProvisions.title}</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.commonProvisions.noWaiver.title}</h3>
                <p className="text-gray-700">{s.commonProvisions.noWaiver.content}</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.commonProvisions.severability.title}</h3>
                <p className="text-gray-700">{s.commonProvisions.severability.content}</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.commonProvisions.assignment.title}</h3>
                <p className="text-gray-700">{s.commonProvisions.assignment.content}</p>
              </div>
            </div>
          </section>

          {/* Modificaciones */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.modifications.title}</h2>
            <div className="space-y-4 text-gray-700">
              <p>{s.modifications.p1}</p>
              <p><strong>{s.modifications.p2}</strong></p>
              <p>{s.modifications.p3}</p>
            </div>
          </section>

          {/* Resolución de disputas */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.disputes.title}</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.disputes.amicable.title}</h3>
                <p className="text-gray-700">{s.disputes.amicable.content}</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.disputes.applicableLaw.title}</h3>
                <p className="text-gray-700">{s.disputes.applicableLaw.content}</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{s.disputes.jurisdiction.title}</h3>
                <p className="text-gray-700">{s.disputes.jurisdiction.content}</p>
                <p className="text-gray-700 mt-2"><strong>{s.disputes.jurisdiction.exception}</strong></p>
              </div>
            </div>
          </section>

          {/* Definiciones */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.definitions.title}</h2>
            <div className="space-y-4">
              {['application', 'agreement', 'owner', 'service', 'user', 'consumer'].map((key) => (
                <div key={key}>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{s.definitions[key].title}</h3>
                  <p className="text-gray-700">{s.definitions[key].content}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contacto */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">{s.contact.title}</h2>
            <div className="bg-blue-50 p-6 rounded-lg">
              <p className="text-gray-700 mb-2">{s.contact.intro}</p>
              <div className="space-y-2">
                <p className="text-gray-700">
                  <strong>{s.contact.email}:</strong>
                  <a href="mailto:support@farmway.dev" className="text-blue-600 hover:text-blue-800 ml-1">
                    support@farmway.dev
                  </a>
                </p>
                <p className="text-gray-700">
                  <strong>{s.contact.addressLabel}:</strong> Gran Vía Carles III, 98, 10º, 08028 Barcelona, España
                </p>
              </div>
            </div>
          </section>

          {/* Fecha de actualización */}
          <section className="border-t pt-6">
            <p className="text-sm text-gray-500">
              {t('termsOfService.effectiveDate').replace('{date}', lastUpdatedDate)}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              {t('termsOfService.lastUpdated').replace('{date}', lastUpdatedDate)}
            </p>
          </section>

        </div>

        {/* Botón de volver */}
        <div className="mt-8 text-center">
          <button
            onClick={() => window.history.back()}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200"
          >
            {t('termsOfService.backButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
